export default __webpack_public_path__ + "static/media/service-at-cutis.c86bb60f.pdf";